import { SupportRequestType } from './ContactUsModal'

export const BUG_ISSUE_OPTIONS = [
  'supportRequest.bug.option.incorrectOdds',
  'supportRequest.bug.option.desynchronizedStatuses',
  'supportRequest.bug.option.wrongStatistics',
  'supportRequest.bug.option.subscriptionAccess',
  'supportRequest.bug.option.manipulationRisks',
  'supportRequest.bug.option.other',
]

export const CONTACT_MODAL_CONFIG: Record<SupportRequestType, {
  headerKey: string
  titleKey: string
  subtitleKey?: string
  icon: string
  subjectPrefixKey: string
  subjectPlaceholderKey: string
  messageLabelKey: string
  messagePlaceholderKey: string
  extraLabelKey?: string
  extraPlaceholderKey?: string
}> = {
  support: {
    headerKey: 'supportRequest.support.header',
    titleKey: 'supportRequest.support.title',
    icon: '/assets/images/help-center/headphones.svg',
    subjectPrefixKey: 'supportRequest.support.subjectPrefix',
    subjectPlaceholderKey: 'supportRequest.support.subjectPlaceholder',
    messageLabelKey: 'supportRequest.support.messageLabel',
    messagePlaceholderKey: 'supportRequest.support.messagePlaceholder',
  },
  bug: {
    headerKey: 'supportRequest.bug.header',
    titleKey: 'supportRequest.bug.title',
    subtitleKey: 'supportRequest.bug.subtitle',
    icon: '/assets/images/help-center/bugreport.svg',
    subjectPrefixKey: 'supportRequest.bug.subjectPrefix',
    subjectPlaceholderKey: 'supportRequest.bug.subjectPlaceholder',
    messageLabelKey: 'supportRequest.bug.messageLabel',
    messagePlaceholderKey: 'supportRequest.bug.messagePlaceholder',
  },
  feature: {
    headerKey: 'supportRequest.feature.header',
    titleKey: 'supportRequest.feature.title',
    subtitleKey: 'supportRequest.feature.subtitle',
    icon: '/assets/images/help-center/feature.svg',
    subjectPrefixKey: 'supportRequest.feature.subjectPrefix',
    subjectPlaceholderKey: 'supportRequest.feature.subjectPlaceholder',
    messageLabelKey: 'supportRequest.feature.messageLabel',
    messagePlaceholderKey: 'supportRequest.feature.messagePlaceholder',
  },
}
